import { render, staticRenderFns } from "./AntProducts.vue?vue&type=template&id=132a03bd&scoped=true"
import script from "./AntProducts.vue?vue&type=script&lang=js"
export * from "./AntProducts.vue?vue&type=script&lang=js"
import style0 from "./AntProducts.vue?vue&type=style&index=0&id=132a03bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a03bd",
  null
  
)

export default component.exports